// import Vue from 'vue';


(
    function ($) {
        'use strict';

        var Site = {
            $searchContainer: $('.header--search'),
            $actionButtons: $('.action--buttons'),
            $boxSubnav: $('.box--subnav'),

            /**
             * Toggle the search form in the header.
             */
            toggleSearchForm: function () {
                this.$searchContainer.stop().slideToggle();
                $('.search-form-input', this.$searchContainer).focus();

                return false;
            },

            /**
             * Toggle navigation in the header.
             *
             * @param element
             */
            toggleNav: function (element) {
                $(element.currentTarget).toggleClass('on');
                $('.header .navigation').toggleClass('on');

                return false;
            },

            /**
             * Toggle sub navigation in the header.
             *
             * @param element
             */
            toggleSubNav: function (element) {
                var $element = $(element.currentTarget);
                $element.toggleClass('hover-active');

                return false;
            },

            /**
             * Fixed action bar on scroll
             */
            fixedActionBar: function() {
                var fixmeTop = Site.$actionButtons.offset().top;

                $(window).scroll(function() {
                    var currentScroll = $(window).scrollTop();

                    if (currentScroll >= fixmeTop) {
                        var rt = ($(window).width() - (Site.$actionButtons.offset().left + Site.$actionButtons.outerWidth()));
                        Site.$actionButtons.addClass('is-fixed');
                        Site.$actionButtons.css({
                                                    position: 'fixed',
                                                    right: rt
                                                });
                    } else {
                        Site.$actionButtons.removeClass('is-fixed');
                        Site.$actionButtons.css({
                                                    position: '',
                                                    right: ''
                                                });
                    }

                });

                $(window).on('resize', function() {
                    if ($(window).width() < 640) {
                        Site.$actionButtons.css({
                                                    position: '',
                                                    right: ''
                                                });
                    } else {
                        var subclass = (Site.$boxSubnav.offset().left + Site.$boxSubnav.outerWidth() + 20);
                        subclass = $(window).width() - subclass - Site.$actionButtons.outerWidth();

                        if (Site.$actionButtons.hasClass('is-fixed')) {
                            Site.$actionButtons.css({right: subclass});
                        }
                    }
                });
            },

            /**
             * Init call.
             */
            init: function () {
                if (Site.$actionButtons.length && $(window).width() > 640) {
                    Site.fixedActionBar();
                }
            }
        };

        $(document).on({
            click: $.proxy(Site, 'toggleSearchForm')
        }, '.search-toggle');

        $(document).on({
            click: $.proxy(Site, 'toggleNav')
        }, '.nav-toggle');

        $(document).on({
            touchstart: $.proxy(Site, 'toggleSubNav')
        }, '.has-subnav');
        window.onload = function () {
            Site.init();
        };
    }(jQuery)
);